import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'

export const useAppDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      paddingRight: theme.spacing(9),
      paddingBottom: theme.spacing(1),
    },
    formContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2.5),
      paddingTop: theme.spacing(1),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],

      '&:hover': {
        color: theme.palette.grey[700],
        backgroundColor: theme.palette.action.hover,
      },

      '& .MuiSvgIcon-root': {
        marginRight: '0!important',
      },
    },
    fieldBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    label: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.body2.fontSize,
      fontWeight: 600,
    },
    commonRejectionReasonSelector: {
      width: '100%',
    },
    dialogActions: {
      padding: theme.spacing(2, 3, 3),
    },
    button: {
      minWidth: 96,
    },
  })
)
